<template>
  <div>
    <el-menu
      :default-active="$store.state.ta"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="#20243F"
      text-color="#fff"
      active-text-color="#FFF"
    >
      <!-- <el-menu-item index="1">首页</el-menu-item>
      <el-menu-item index="2">项目库管理</el-menu-item>
      <el-menu-item index="3">票据管理</el-menu-item>
      <el-menu-item index="4">系统管理</el-menu-item> -->
      <template v-for="(item,index) in menuList">
        <el-menu-item
          :index="''+(index+1)"
          :key="index"
        >{{item.label}}</el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
const w = {
  data() {
    return {
      activeIndex: "1",
      menuList: [{ label: "首页" }],
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      sessionStorage.setItem("menu.top.active", key);
      this.$emit("top-change", key, true);
    },
    setData(data) {
      console.log("setData", data);
      this.menuList.length = 1;
      for (let i = 1; i < data.length; i++) {
        let t = data[i];
        console.log(t);
        this.menuList.push({
          label: t.title,
        });
      }
    },
  },
  created() {
    // let active = null;
    // active = sessionStorage.getItem("menu.top.active");
    // console.log("menu.top.active", active);
    // if (active) {
    //   this.$store.commit("ta", active);
    //   this.$emit("top-change", active, false);
    // }
  },
};
export default w;
</script>
<style scoped>
.el-menu-item {
  height: 67px;
  line-height: 67px;
}

.el-menu-item.is-active {
  background-color: #3370ff !important;
  border-bottom-color: #3370ff !important;
}

.el-menu-item:hover {
  background-color: #3370ff !important;
}

.el-menu-item.is-active span {
  color: #fff !important;
}
</style>
